timeInSeconds